import {
  Configuration,
  LogLevel,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser';

const AzureActiveDirectoryAppClientId: string = process.env
  .REACT_APP_AD_CLIENT_ID as string;

export const MSAL_CONFIG: Configuration = {
  auth: {
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_TENANT_ID}/`,
    clientId: AzureActiveDirectoryAppClientId,
    redirectUri: `${window.location.origin}/oauth-handler`,
    postLogoutRedirectUri: `${window.location.origin}/`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ): void => {
        if (containsPii || process.env.REACT_APP_ENVIRONMENT === 'production') {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

export const loginRequest: RedirectRequest = {
  scopes: [
    'openid',
    'https://graph.microsoft.com/User.Read',
    'https://graph.microsoft.com/Files.Read',
    'https://graph.microsoft.com/Files.Read.All',
    'https://graph.microsoft.com/Files.ReadWrite.All',
    'https://graph.microsoft.com/Sites.Read.All',
    'https://graph.microsoft.com/Team.ReadBasic.All',
    'https://graph.microsoft.com/Group.Read.All',
    'https://graph.microsoft.com/ChannelSettings.Read.All',
  ],
};

export const backendRequest: RedirectRequest = {
  scopes: ['api://5ea6ab64-d790-481b-87d0-6c6238bd6473/access_as_user'],
};
